var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "employees-card",
          attrs: { "body-style": { padding: "20px 20px 20px 20px" } },
        },
        [
          _c("oaFromBox", {
            staticClass: "from-box",
            attrs: {
              title: _vm.$route.meta.title,
              btnText: "添加合同",
              treeData: _vm.treeDataGroup,
              search: _vm.search,
              viewSearch: _vm.viewSearch,
              dropdownList: _vm.dropdownList,
              total: _vm.total,
              isAddBtn: _vm.types == 1,
            },
            on: {
              treeChange: _vm.handleNodeClick,
              addDataFn: _vm.addContract,
              dropdownFn: _vm.dropdownFn,
              confirmData: _vm.confirmData,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    height: _vm.tableHeight,
                    "default-expand-all": "",
                    "row-key": "id",
                  },
                  on: {
                    "selection-change": _vm.handleSelectionChange,
                    "sort-change": _vm.changeTimeSort,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { "min-width": "55", type: "selection" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.tableHeaders, function (header) {
                    return _c("el-table-column", {
                      key: header.field,
                      attrs: {
                        label: header.name,
                        "min-width":
                          header.input_type == "file" ? "300" : "160",
                        prop: header.field,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                header.field == "creator" &&
                                scope.row[header.field]
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row[header.field].name)
                                      ),
                                    ])
                                  : header.field == "customer_way"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row[header.field][0] || "--"
                                        )
                                      ),
                                    ])
                                  : header.field == "contract_followed"
                                  ? _c("div", { staticClass: "icon-star" }, [
                                      _c("i", {
                                        staticClass: "pointer",
                                        class:
                                          scope.row.contract_followed === 0
                                            ? "el-icon-star-off"
                                            : "el-icon-star-on color-collect icon-star-on",
                                        on: {
                                          click: function ($event) {
                                            return _vm.focusEvt(scope.row)
                                          },
                                        },
                                      }),
                                    ])
                                  : header.field == "contract_label"
                                  ? _c(
                                      "div",
                                      { staticClass: "pointer" },
                                      _vm._l(
                                        scope.row[header.field],
                                        function (item) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: item.id,
                                              staticClass: "customer-tag",
                                              attrs: { size: "small" },
                                            },
                                            [_vm._v(_vm._s(item.name || "--"))]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : header.field == "liaison_tel"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row[header.field]
                                            ? scope.row[header.field]
                                                .liaison_name
                                            : ""
                                        ) +
                                          _vm._s(
                                            scope.row[header.field]
                                              ? "："
                                              : "--"
                                          ) +
                                          _vm._s(
                                            scope.row[header.field]
                                              ? scope.row[header.field]
                                                  .liaison_tel
                                              : ""
                                          )
                                      ),
                                    ])
                                  : header.field == "salesman" &&
                                    scope.row[header.field]
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row[header.field].name)
                                      ),
                                    ])
                                  : header.field == "area_cascade"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row[header.field][0] || "--"
                                        )
                                      ),
                                    ])
                                  : header.field == "contract_status"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            staticClass: "contract-status-tag",
                                            attrs: {
                                              type: _vm.getContractTag(
                                                scope.row
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getContractTexts(scope.row)
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : header.field == "signing_status"
                                  ? _c(
                                      "div",
                                      [
                                        scope.row[header.field] == 0
                                          ? _c(
                                              "el-tag",
                                              {
                                                staticClass: "customer-tag",
                                                attrs: { size: "small" },
                                              },
                                              [_vm._v("未签约")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row[header.field] == 1
                                          ? _c(
                                              "el-tag",
                                              {
                                                staticClass: "customer-tag",
                                                attrs: {
                                                  size: "small",
                                                  type: "success",
                                                },
                                              },
                                              [_vm._v("已签约")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row[header.field] == 2
                                          ? _c(
                                              "el-tag",
                                              {
                                                staticClass: "customer-tag",
                                                attrs: {
                                                  size: "small",
                                                  type: "danger",
                                                },
                                              },
                                              [_vm._v("作废")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : header.field == "bill_no" &&
                                    scope.row[header.field]
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        scope.row[header.field],
                                        function (item, index) {
                                          return _c("div", { key: item.id }, [
                                            _c(
                                              "div",
                                              { staticClass: "line1" },
                                              [_vm._v(_vm._s(item.bill_no))]
                                            ),
                                            _vm._v(" "),
                                            item.bill_no &&
                                            index <
                                              scope.row[header.field].length - 1
                                              ? _c("span", [_vm._v("、")])
                                              : _vm._e(),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : header.field == "contract_category"
                                  ? _c(
                                      "span",
                                      _vm._l(
                                        scope.row[header.field],
                                        function (item, index) {
                                          return _c("span", { key: index }, [
                                            _vm._v(_vm._s(item || "--")),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : header.field == "contract_customer"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "point",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleClient(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row[header.field]
                                              ? scope.row[header.field]
                                                  .customer_name
                                              : "--"
                                          )
                                        ),
                                      ]
                                    )
                                  : header.field == "contract_name"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "point",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleCheck(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row[header.field] || "--"
                                          )
                                        ),
                                      ]
                                    )
                                  : header.field == "payment_status"
                                  ? _c("span", [
                                      scope.row[header.field] == 1
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#19be6b" },
                                            },
                                            [_vm._v("已结清")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row[header.field] == 0
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#ff9900" },
                                            },
                                            [_vm._v("未结清")]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row[header.field] || "--")
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("public.operation"),
                        fixed: "right",
                        prop: "address",
                        width: "200",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["customer:contract:check"],
                                      expression: "['customer:contract:check']",
                                    },
                                  ],
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleCheck(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("public.check")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addContract(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 编辑合同 ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dropdown",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-dropdown-link el-button--text el-button more",
                                    },
                                    [
                                      _vm._v(
                                        "\n                更多\n                "
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-arrow-down",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticClass: "dropdown-menu-left",
                                      attrs: { placement: "top-start" },
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleBuild(
                                                scope.row,
                                                _vm.buildData
                                                  .contract_refund_switch,
                                                "contract_refund_switch"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  添加回款\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleBuild(
                                                scope.row,
                                                _vm.buildData
                                                  .contract_renew_switch,
                                                "contract_renew_switch"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  添加续费\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleBuild(
                                                scope.row,
                                                _vm.buildData
                                                  .contract_disburse_switch,
                                                "contract_disburse_switch"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  添加支出\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleBuild(
                                                scope.row,
                                                _vm.buildData.invoicing_switch,
                                                "invoicing_switch"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  申请发票\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleTransfer(
                                                2,
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 移交同事 ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.markedAbnormal(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                scope.row.contract_status == 3
                                                  ? "标为正常合同"
                                                  : "标为异常合同"
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleDelete(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(" 删除 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _vm._v("\n            操作\n            "),
                        _c("i", {
                          staticClass: "el-icon-setting pointer",
                          on: { click: _vm.customSearchEvt },
                        }),
                      ]),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-fixed" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.where.limit,
                  "current-page": _vm.where.page,
                  "page-sizes": [15, 20, 30],
                  layout: "total, sizes,prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("add-contract", {
        ref: "addContract",
        attrs: { "form-data": _vm.contractFromData },
        on: {
          getTableData: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("edit-contract", {
        ref: "editContract",
        attrs: { "form-data": _vm.fromData },
        on: {
          isOk: function ($event) {
            return _vm.getTableData(true)
          },
        },
      }),
      _vm._v(" "),
      _c("edit-customer", {
        ref: "editCustomer",
        attrs: { "form-data": _vm.fromData },
        on: {
          isOkEdit: function ($event) {
            return _vm.getTableData(true)
          },
        },
      }),
      _vm._v(" "),
      _c("transfer-dialog", {
        ref: "transferDialog",
        attrs: { "from-data": _vm.transferData },
        on: { handleTransfer: _vm.getTableData },
      }),
      _vm._v(" "),
      _vm.tableItemDialogVisible
        ? _c("visible-dialog", {
            attrs: {
              "default-table-item-list": _vm.defaultTableItemList,
              "table-item-dialog-visible": _vm.tableItemDialogVisible,
              "transfer-data-list": _vm.transferDataList,
              "transfer-props": { key: "field", label: "name" },
              "visible-table-item-list": _vm.visibleTableItemList,
            },
            on: {
              handleCloseTableItem: _vm.handleCloseTableItem,
              handleConfirmVisible: _vm.handleConfirmVisible,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { ids: _vm.formInfo.id, parameterData: _vm.parameterData },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          "export-data": _vm.exportData,
          "save-name": _vm.saveName,
          template: false,
        },
      }),
      _vm._v(" "),
      _c("import-excel", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "importExcel",
        on: { importExcelData: _vm.importExcelData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }